let ETC = {
  // ETC_URL: 'https%3A%2F%2Fqa.h5.etczs.net',
  // ETC_URL: 'https%3A%2F%2Fh5.etczs.net/payBack',
  PAKD_URL: process.env.VUE_APP_PAKD_URL,
  APP_CHANNEL_PL: {
    didi1: 243,
    didi2: 244,
    weiche: 124,
    kuaigou: 125,
    huolala: 108,
    tencent: 41,
    qqmap: 126,
    zhaohang: 123,
    // pahcz: 121,
    toutiao: 122,
    pingankoudai: '',
    ByteDanceDY: 261,
    ByteDanceHS: 262,
    ByteDanceXG: 263,
    zuizhuhai: 400,
    baidu: 1226
  },
  //  third_type
  APP_LOGIN_TYPES: {
    didi1: 24,
    didi2: 25,
    weiche: 2,
    kuaigou: 3,
    huolala: 6,
    tencent: 11,
    qqmap: 12,
    // zhaohang: 16,
    // pahcz: 21,
    toutiao: 22,
    pingankoudai: 23,
    ByteDanceDY: 26,
    ByteDanceHS: 27,
    ByteDanceXG: 28,
    // zuizhuhai: 31,
    baidu: 32
  },
  APP_EVNS_CN: {
    didi1: '滴滴-车主服务',
    didi2: '滴滴-代驾',
    weiche: '微车APP',
    kuaigou: '快狗APP',
    huolala: '货拉拉APP',
    tencent: '腾讯',
    qqmap: '腾讯地图',
    zhaohang: '招商银行',
    // pahcz: '平安好车主',
    toutiao: '头条',
    ByteDanceHS: '火山',
    ByteDanceDY: '抖音',
    ByteDanceXG: '西瓜',
    pingankoudai: '平安口袋银行',
    zuizhuhai: '最珠海',
    baidu: '手机百度'
  },
  APP_SCHEME: {
    weiche: 'bd-martin://',
    kuaigou: 'suyundriver://',
    huolala: 'huolala-driver://',
    qqmap: 'qqmap://',
    zuizhuhai: 'zhuhai.smt.com://',
    baidu: 'baiduboxapp://'
  },
  CHOOSE_BANKS: [
    // {
    //   choice_id: 14,
    //   free_type: 4,
    //   // province: ['江苏省'],
    //   type: '借记卡/信用卡',
    //   credit_card_bank: 14,
    //   issuer: 25,
    //   title: '工商银行',
    //   protocol: 'ICBC_BANK_SERVE_PROTOCOL',
    //   shot_name: '工商银行',
    //   component: 'cSpecifyBankApply',
    //   label: '绑定工商银行卡',
    //   tag: '8-15天拿到设备',
    //   img_url:
    //     'https://wecos.etczs.net/pages/newApply/assets/images/gs-credit-bank-card-0810.png',
    //   item_info_active: false,
    //   status: 0,
    //   hideFreeType: ['credit', 'free', 'coupon'],
    //   ex_btn: '绑定微信支付，即可免费办理',
    //   ex_content: [{ text: '选择工商银行卡作为微信支付免密扣款账户' }]
    // },
    // {
    //   choice_id: 12,
    //   free_type: 4,
    //   type: '借记卡/信用卡',
    //   credit_card_bank: 12,
    //   // gift: '送24元',
    //   plate: ['青', '川', '甘', '宁', '蒙', '陕', '晋', '豫', '鲁', '新', '京', '津', '冀', '辽', '吉', '黑'],
    //   title: '农业银行',
    //   protocol: 'ABC_BANK_SERVE_PROTOCOL',
    //   component: 'cSpecifyBankApply',
    //   label: '绑定农业银行卡',
    //   notKing: true,
    //   issuer: 2,
    //   shot_name: '农业银行',
    //   tag: '8-15天拿到设备',
    //   img_url: 'https://wecos.etczs.net/pages/newApply/assets/images/ny-credit-bank-card-0805.png',
    //   item_info_active: false,
    //   status: 0,
    //   // 中只发江苏王卡，青海地推只有符合免费条件的时候才会走地推所以暂不屏蔽，其他地推均屏蔽招行选项
    //   hideFreeType: ['credit', 'free', 'coupon'],
    //   ex_btn: '绑定微信支付，即可免费办理',
    //   ex_content: [{ text: '选择农业银行卡作为微信支付免密扣款账户' }]
    // },
    // {
    //   choice_id: 19,
    //   free_type: 4,
    //   type: '借记卡/信用卡',
    //   credit_card_bank: 23,
    //   // hideInList: true,
    //   // gift: '送24元',
    //   title: '农业银行',
    //   protocol: 'ABC_BANK_SERVE_PROTOCOL',
    //   component: 'cSpecifyBankApply',
    //   label: '绑定农业银行卡',
    //   plate: ['领'],
    //   issuer: 25,
    //   shot_name: '广西农业银行',
    //   tag: '8-15天拿到设备',
    //   img_url: 'https://wecos.etczs.net/pages/newApply/assets/images/ny-credit-bank-card-0805.png',
    //   item_info_active: false,
    //   status: 0,
    //   hideFreeType: ['credit', 'free', 'coupon'],
    //   ex_btn: '绑定微信支付，即可免费办理',
    //   ex_content: [{ text: '选择农业银行卡作为微信支付免密扣款账户' }]
    // },
    // {
    //   choice_id: 22,
    //   free_type: 4,
    //   type: '借记卡/信用卡',
    //   credit_card_bank: 35,
    //   // hideInList: true,
    //   // gift: '送24元',
    //   title: '农业银行',
    //   protocol: 'ABC_BANK_SERVE_PROTOCOL',
    //   component: 'cSpecifyBankApply',
    //   label: '绑定农业银行卡',
    //   plate: ['浙', '皖', '苏', '沪', '闽', '赣', '鄂', '琼', '渝', '藏', '粤', '桂', '云', '湘', '贵'],
    //   issuer: 1,
    //   shot_name: '江苏农业银行',
    //   tag: '8-15天拿到设备',
    //   img_url: 'https://wecos.etczs.net/pages/newApply/assets/images/ny-credit-bank-card-0805.png',
    //   item_info_active: false,
    //   status: 0,
    //   hideFreeType: ['credit', 'free', 'coupon'],
    //   ex_btn: '绑定微信支付，即可免费办理',
    //   ex_content: [{ text: '选择农业银行卡作为微信支付免密扣款账户' }]
    // },
    {
      choice_id: 17,
      free_type: 4,
      plate: ['京'],
      // noPlate: '苏',
      type: '借记卡/信用卡',
      issuer: 2,
      notKing: true,
      label: '绑定中国银行卡',
      protocol: 'BOC_BANK_SERVE_PROTOCOL',
      component: 'cSpecifyBankApply',
      // credit_card_bank: 9,
      credit_card_bank: 17,
      // gift: '送24元/保险',
      giftSmallFont: true,
      title: '中国银行',
      shot_name: '北京中行',
      tag: '8-15天拿到设备',
      img_url:
        'https://wecos.etczs.net/pages/newApply/assets/images/zg-credit-bank-card-0725.png',
      item_info_active: false,
      status: 0,
      // 中只发江苏王卡，青海地推只有符合免费条件的时候才会走地推所以暂不屏蔽，其他地推均屏蔽招行选项
      hideFreeType: ['credit', 'free', 'coupon'],
      ex_btn: '绑定微信支付，即可免费办理',
      ex_content: [
        { text: '选择中国银行卡作为微信支付免密扣款账户' },
        { text: '通行费95折基础上再享8折优惠（每月封顶20元）' }
      ]
    },
    {
      choice_id: 9,
      free_type: 4,
      noPlate: ['京'],
      type: '借记卡/信用卡',
      issuer: 1,
      label: '绑定中国银行卡',
      protocol: 'BOC_BANK_SERVE_PROTOCOL',
      component: 'cSpecifyBankApply',
      // credit_card_bank: 9,
      credit_card_bank: 20,
      // gift: '送24元/保险',
      giftSmallFont: true,
      title: '中国银行',
      shot_name: '江苏中行',
      tag: '8-15天拿到设备',
      img_url:
        'https://wecos.etczs.net/pages/newApply/assets/images/zg-credit-bank-card-0725.png',
      item_info_active: false,
      status: 0,
      // 中只发江苏王卡，青海地推只有符合免费条件的时候才会走地推所以暂不屏蔽，其他地推均屏蔽招行选项
      hideFreeType: ['credit', 'free', 'coupon'],
      ex_btn: '绑定微信支付，即可免费办理',
      ex_content: [
        { text: '选择中国银行卡作为微信支付免密扣款账户' },
        { text: '通行费95折基础上再享8折优惠（每月封顶20元）' }
      ]
    },
    // {
    //   choice_id: 18,
    //   free_type: 4,
    //   type: '借记卡/信用卡',
    //   credit_card_bank: 22,
    //   issuer: 25,
    //   component: 'cSpecifyBankApply',
    //   title: '建设银行',
    //   protocol: 'CCB_BANK_SERVE_PROTOCOL',
    //   shot_name: '广西建行',
    //   label: '绑定建设银行卡',
    //   tag: '8-15天拿到设备',
    //   img_url:
    //     'https://wecos.etczs.net/pages/newApply/assets/images/js-credit-bank-card-0715.png',
    //   item_info_active: false,
    //   status: 0,
    //   hideFreeType: ['credit', 'free', 'coupon'],
    //   ex_btn: '绑定微信支付，即可免费办理',
    //   ex_content: [{ text: '选择建设银行卡作为微信支付免密扣款账户' }]
    // },
    {
      choice_id: 29,
      free_type: 0,
      type: '',
      credit_card_bank: 0,
      pageType: 1,
      showIn9BlockWeekList: true,
      testType: 'A',
      title: '其他银行',
      shot_name: '99元保证金',
      label: '其他银行',
      component: 'cDepositApply',
      plate: 'all',
      // hideInList: true,
      // showPl: [44, 64, 106, ...NIGHT_BLOCK, ...LIKE_NIGHT_BLOCK],
      tag: '8-15天拿到设备',
      // img_url: 'https://wecos.etczs.net/pages/newApply/assets/images/deposit-card-0704.png',
      img_url:
        'https://wecos.etczs.net/H5/newApply/other-bank.png',
      item_info_active: false,
      week_list: true,
      status: 0,
      issuer: 25
    }
  ],
  ISSUER_DISCOUNT: {
    苏通卡: {
      discount: (province, cardType) =>
        province === '江苏省' ? (cardType === 1 ? 0 : 98) : 0
    },
    粤通卡: {
      // 广东
      discount: () => 98
    },
    鲁通卡: {
      discount: province => (province === '山东省' ? 95 : 0)
    },
    徽通卡: {
      discount: province => (province === '安徽省' ? 95 : 0)
    },
    青通卡: {
      // 青海
      discount: () => 95
    },
    速通卡: {
      // 北京
      discount: () => 95
    },
    沪通卡: {
      discount: province => (province === '上海市' ? 95 : 0)
    },
    浙通卡: {
      discount: province => (province === '浙江省' ? 97 : 0)
    },
    翼通卡: {
      // 河北
      discount: () => 95
    },
    闽通卡: {
      discount: (province, cardType) =>
        province === '福建省' ? (cardType === 1 ? 98 : 95) : 0
    },
    黔通卡: {
      discount: province => (province === '贵州省' ? 95 : 0)
    },
    天津速通卡: {
      // 天津市
      discount: () => 95
    },
    晋通卡: {
      // 山西省
      discount: () => 95
    },
    辽通卡: {
      // '辽宁省'
      discount: () => 0
    },
    赣通卡: {
      discount: (province, cardType) =>
        province === '江西省' ? (cardType === 1 ? 98 : 95) : 0
    },
    湘通卡: {
      // 湖南省
      discount: () => 95
    },
    秦通卡: {
      discount: province => (province === '陕西省' ? 95 : 0)
    },
    中原通卡: {
      // 河南
      discount: () => 95
    },
    通衢卡: {
      discount: province => (province === '湖北省' ? 95 : 0)
    },
    通渝卡: {
      // 重庆市
      discount: () => 97
    },
    龙通卡: {
      discount: province => (province === '黑龙江省' ? 95 : 0)
    },
    吉通卡: {
      // 吉林省
      discount: () => 0
    },
    蜀通卡: {
      // 四川省
      discount: () => 95
    },
    云通卡: {
      // 云南省
      discount: () => 95
    },
    陇原通卡: {
      discount: province => (province === '甘肃省' ? 95 : 0)
    },
    八桂行卡: {
      discount: province => (province === '广西壮族自治区' ? 97 : 0)
    },
    宁通卡: {
      // 宁夏回族自治区
      discount: () => 95
    },
    天山行: {
      // '新疆维吾尔自治区'
      discount: () => 0
    },
    蒙通卡: {
      // '内蒙古自治区'
      discount: () => 0
    }
  },
  ACTIVITY_LIST: [
    {
      tag: '路费补贴',
      name: '成功申办并通行扣费成功后可参与抽奖',
      isShow: new Date().getTime() < new Date(2019, 0, 4).getTime()
    }
  ],
  NEW_APPLY_QA: [
    {
      question: '什么车辆可以办理？',
      answer: '暂仅支持9座及9座以下的蓝牌、绿牌的个人小型汽车办理，本渠道暂不支持货车办理。'
    },
    {
      question: '非本人车辆是否可以办理？',
      answer: '可以办理，需上传车主的身份证和车辆行驶证原件照片。'
    },
    {
      question: '办理需要提交什么证件资料？',
      answer: '需要提供车主本人的身份证原件照片、车辆行驶证原件照片、车辆正面照片(含车牌信息)。'
    },
    {
      question: '办理需要多久才能收到设备？',
      answer: '填写车牌和收货地址、支付费用，待资格审核通过即可发货，最快当天即可快递寄出。'
    },
    {
      question: '已经办理过ETC了还可以办理吗？',
      answer: '不可以，交通部规定一辆车仅允许办理一个ETC设备，需要在原办理渠道注销原账户后才能重新申办。'
    },
    {
      question: '是否全国通行？全国高速95折？',
      answer: '全国高速公路已实现联网，任何ETC设备均可通行，目前国家规定ETC通行高速享受≥5%的优惠。'
    },
    {
      question: '通行后如何扣费？',
      answer: '设备激活时需签约微信支付，通行高速后费用通过微信支付完成扣费，扣费会有延迟，一般是通行当天扣费，部分路段会有数天延迟。'
    },
    {
      question: 'ETC是否有被盗刷的风险？',
      answer: 'ETC助手申办的卡片设备为ETC专用设备，专车专用，仅限通行ETC车道，不具有银行卡功能，不存在盗刷风险。'
    },
    {
      question: '如何安装？',
      answer: '只需要根据ETC助手小程序上的步骤提示，打开手机蓝牙连接设备，1分钟即可完成自助安装。'
    }
  ],
  ISSUER_IDS: {
    js: 1,
    bj: 2,
    gd: 3,
    sd: 6,
    hb: 7,
    jl: 21,
    gx: 25,
    gz: 9,
    qh: 26,
    nmg: 28
  },
  MONTH_NUM: 125676, // 月办理量
  NEW_APPLY_STEP_TEXT: ['支付完成', '设备定制', '安装设备'],
  COMMON_PROTOCOL: {
    PAYMENT_ENTRUST: true,
    INTEGRITY_ENTRUST: true,
    TENCENT_INTEGRITY: true,
    USER_SERVE_PROTOCOL: true,
    USER_PRIVACY_PROTECTION_PROTOCOL: true,
    KING_USER_SERVE_PROTOCOL: false,
    MEMBER_SERVICE_PROTOCOL: true,
    CMB_BANK_SERVE_PROTOCOL: true
  },
  LOCAL_STORAGE_KEY: {
    // PAHCZ_OPENID: 'pahcz_openid',
    HOME_RELOAD: 'HOME_RELOAD',
    TOKEN: 'token',
    TOKEN_EXPIRE_TIME: 'TOKEN_EXPIRE_TIME', // token 过期时间
    LOGIN_PHONE: 'login_phone', // 登录手机号码
    UUID: 'uuid',
    ETC_UID: 'etc_uid',
    APP_FROM_CHANNEL: 'from_channel',
    GOODS_DETAIL_PLATE_NO: 'goods_detail_plate_no', // 包括车牌号
    GOODS_DETAIL_PLATE_COLOR: 'goods_detail_plate_color', // 车牌颜色
    KUAI_GOU_HOME_MODAL: 'KUAI_GOU_HOME_MODAL', // 快狗首页优惠券弹窗
    ZHONG_AN_MODAL: 'ZHONG_AN_MODAL', // 众安上传身份证页弹窗
    ENTRY: 'entry',
    ZHAO_HANG_RECOMMEND: 'zhao_hang_recommend'
  },
  SESSION_STORAGE_KEY: {
    ZHAO_HANG_LOGIN: 'zhao_hang_login',
    CUSTOM_ISSUER: 'custom_issuer'
    // PAHCZ_CODE: 'pahcz_code'
  },
  QA_PAGE_IDS: {
    goodsDetail: { card_id: '0', page_id: 5000150 }, // 首页
    uploadIDCard: { page_id: 2000106, card_id: '0' },
    uploadVehicle: { page_id: 2000206, card_id: '0' },
    orderInfo: { page_id: 2000106, card_id: '0' }
  },
  BI_PAGES: {
    home: '1000100',
    goodsDetail: '2001100',
    goodsDetailV1: '2001100',
    goodsAddress: '2001200',
    goodsPay: '2002100'
  },
  PAHCZ_BI_PAGES: {
    applyProgress: {
      pageId: 'OCS_H00023998',
      pageName: '曝光ETC助手办理进度页'
    },
    uploadIDCard: {
      pageId: 'OCS_H00023997',
      pageName: '曝光ETC助手上传行驶证页'
    },
    uploadVehicle: {
      pageId: 'OCS_H00023996',
      pageName: '曝光ETC助手上传身份证页'
    },
    uploadSubmit: {
      pageId: 'OCS_H00023995',
      pageName: 'ETC助手上传证件页-点击提交'
    },
    uploadCredentials: {
      pageId: 'OCS_H00023994',
      pageName: '曝光ETC助手上传证件页'
    },
    chooseBankNoBank: {
      pageId: 'OCS_H00023993',
      pageName: 'ETC助手绑定银行卡页-点击暂无以上银行'
    },
    chooseBank: {
      pageId: 'OCS_H00023992',
      pageName: '曝光ETC助手绑定银行卡页'
    },
    submitAddress: {
      pageId: 'OCS_H00023991',
      pageName: 'ETC助手填写资料页-点击下一步'
    },
    goodsAddress: {
      pageId: 'OCS_H00023990',
      pageName: '曝光ETC助手填写资料页'
    },
    apply: {
      pageId: 'OCS_H00023989',
      pageName: 'ETC助手介绍页-点击免费办理'
    },
    goodsDetail: {
      pageId: 'OCS_H00023988',
      pageName: '曝光ETC助手介绍页'
    }
  },
  PLATE_COLOR: {
    '蓝色': 0,
    '黄色': 1,
    '黑色': 2,
    '白色': 3,
    '渐变绿色': 4,
    '黄绿双拼色': 5,
    '蓝白渐变色': 6,
    '临时牌照': 7,
    '未确定色': 9,
    '绿色': 11,
    '红色': 12
  }
}
export default ETC

// 取消办理弹窗信息
export const WELFARE = [
  {
    icon: 'icon-cancel-insurance.png',
    text: '最高20万元高速意外险一年',
    subtext: '激活后可领取，每次通行自动增加额度'
  },
  {
    icon: 'icon-cancel-packet.png',
    text: '100元路费现金红包',
    subtext: '邀请2人办理并激活ETC即可得'
  },
  {
    icon: 'icon-cancel-highway.png',
    text: '全国高速通行95折'
  },
  {
    icon: 'icon-cancel-oil.png',
    text: '全国合作加油站加油费8折起'
  }
]

// 货车显示的常见问题列表
export const TRUCK_QA_LIST = [
  { question: '线上办理要收费吗？', answer: '目前免收设备费。根据您选择办理的产品类型不同，应渠道要求，申办时可能需支付保证金/服务费。' },
  { question: '支持哪些车辆类型办理？', answer: '6轴以内的普通货车、专项作业车以及牵引车、集装箱均可办理，每人限办理5辆。' },
  { question: '办理需要多长时间？', answer: '当天16点前提交办理申请最快当天可寄出。' },
  { question: 'ETC如何激活？', answer: '收货后进入小程序确认收货并激活，根据视频提示完成操作，成功即可插卡过高速ETC车道。' },
  { question: '绿通车、集装箱办理后怎么使用？', answer: '安装激活后，每次上高速提前4小时在“中国ETC”微信小程序进行[预约通行]申请，减免当次通行费。' }
]

export const TRUCK_EVALUATE_LIST = [{'avatar': 'https://wecos.etczs.net/pages/truck/evaluate-avatar/1.jpg', 'title': '山东陈师傅', 'content': '国家出了ETC政策后我就一直想办理，孩子给我在微信上办理的，又有折扣又不用排队，很开心。'}, {'avatar': 'https://wecos.etczs.net/pages/truck/evaluate-avatar/2.jpg', 'title': '广州莫师傅', 'content': '使用ETC快1年了，扣费很准确，现在同事基本都用微信ETC'}, {'avatar': 'https://wecos.etczs.net/pages/truck/evaluate-avatar/3.jpg', 'title': '江苏钱师傅', 'content': '一直用微信ETC，服务很靠谱，还有垫付功能，不用担心忘记充钱无法通行'}, {'avatar': 'https://wecos.etczs.net/pages/truck/evaluate-avatar/4.jpg', 'title': '江苏吕师傅', 'content': '我在江苏省内高速都可以打85折，又方便又省钱，ETC是个好东西~'}, {'avatar': 'https://wecos.etczs.net/pages/truck/evaluate-avatar/5.jpg', 'title': '四川鲁师傅', 'content': '微信支付很方便，也不用担心没钱不能通行，而且还有折扣，必须办理'}, {'avatar': 'https://wecos.etczs.net/pages/truck/evaluate-avatar/6.jpg', 'title': '河南黄师傅', 'content': '不用去银行办理很方便，费用清单一笔一笔很清晰，方便随时查看报销'}, {'avatar': 'https://wecos.etczs.net/pages/truck/evaluate-avatar/7.jpg', 'title': '湖南刘师傅', 'content': '我们常年跑高速的，ETC是一定要办理的，微信支付不用充钱很方便'}, {'avatar': 'https://wecos.etczs.net/pages/truck/evaluate-avatar/8.jpg', 'title': '上海施师傅', 'content': '有一次我微信里没有钱了，平台帮我垫付了1000多块，完全没有影响我的通行，很感谢这样的服务'}, {'avatar': 'https://wecos.etczs.net/pages/truck/evaluate-avatar/9.jpg', 'title': '江苏陈师傅', 'content': '过高速路口不用排队，省了不少时间，国家的政策好，还有打折，省钱了'}, {'avatar': 'https://wecos.etczs.net/pages/truck/evaluate-avatar/10.jpg', 'title': '江苏张师傅', 'content': 'ETC助手支付非常便捷，微信自动扣款，帮我省了不少时间！'}, {'avatar': 'https://wecos.etczs.net/pages/truck/evaluate-avatar/11.jpg', 'title': '湖南姜师傅', 'content': '办理ETC之后还有一些额外的福利，加油都有85折，平台想的很周到'}, {'avatar': 'https://wecos.etczs.net/pages/truck/evaluate-avatar/12.jpg', 'title': '浙江孙师傅', 'content': '有了ETC过高速很方便，国家的ETC打折政策真的挺好的'}, {'avatar': 'https://wecos.etczs.net/pages/truck/evaluate-avatar/13.jpg', 'title': '云南李师傅', 'content': '我是个急性子，ETC不用排队，去一次上海高速费还省了200多，会一直使用的'}, {'avatar': 'https://wecos.etczs.net/pages/truck/evaluate-avatar/14.jpg', 'title': '四川齐师傅', 'content': '我是跑长途的，高速费一趟要2000多块，公司先通行后付费，缓解了我的资金压力，我会一直使用的'}, {'avatar': 'https://wecos.etczs.net/pages/truck/evaluate-avatar/15.jpg', 'title': '广东陈师傅', 'content': '微信ETC纯线上办理很方便，现在大家都使用ETC，我都推荐好几个朋友了'}, {'avatar': 'https://wecos.etczs.net/pages/truck/evaluate-avatar/16.jpg', 'title': '北京王师傅', 'content': '我已经使用了几个月了，公司开发票什么的都很简单，非常适合我'}, {'avatar': 'https://wecos.etczs.net/pages/truck/evaluate-avatar/17.jpg', 'title': '湖北陈师傅', 'content': '我对开票功能操作不熟悉，咨询客服，客服很细心教我怎么开票，服务挺好的'}, {'avatar': 'https://wecos.etczs.net/pages/truck/evaluate-avatar/18.jpg', 'title': '陕西杨师傅', 'content': '办理很简单，只需要上传几个证件就行，还有通行折扣，非常便捷'}, {'avatar': 'https://wecos.etczs.net/pages/truck/evaluate-avatar/19.jpg', 'title': '福建陈师傅', 'content': '平台经常有活动，我上个月参加活动拿了200多块钱，现在身边朋友都在用'}, {'avatar': 'https://wecos.etczs.net/pages/truck/evaluate-avatar/20.jpg', 'title': '天津蒋师傅', 'content': 'ETC助手上的客服很贴心，我有什么不懂的咨询他们，他们给我讲的很详细，服务态度也很好'}]
export const TRUCK_APPLY_LIST = [
  {
    'msg': 'A**。 6秒前提交了申办申请',
    'img': 'https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTIOa267Akhew1tZlZRkE0fcxbicE9kLLp8lMr35BMicQcAdujLVKuT5icjNbuLhL34v3ia4W842J366mQ/132'
  },
  {
    'msg': '用户44***26 10秒前提交了申办申请',
    'img': ''
  },
  {
    'msg': '紫* 23秒前提交了申办申请',
    'img': 'https://thirdwx.qlogo.cn/mmopen/vi_32/lauNNcuJ32zKZlxE8xWDNyF4HFQy1fwyPTQxrI9nKurphv2by7m4y9Y3xCbavTfCj1Jow4lLUZfciaabzuYkniaA/132'
  },
  {
    'msg': '🌶* 29秒前提交了申办申请',
    'img': 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEKeibLFHEuB6PG6MbxSs1ZNgpkibwdBvr89BKmPfXGAwjjEbERwdDvf38SaE5ojmnr9veQ3JpwV67TQ/132'
  },
  {
    'msg': '徐* 41秒前提交了申办申请',
    'img': 'https://thirdwx.qlogo.cn/mmopen/vi_32/8uDhegtTPCib9SKRj0vxJpBoRDYNibFGu4uxmzX3GCFYdNdu9FuIqdZ79tpvWmA5hstOKML1VZtu5hK1rMnpN3oA/132'
  },
  {
    'msg': '用户44***86 59秒前提交了申办申请',
    'img': ''
  },
  {
    'msg': '，* 1分钟前提交了申办申请',
    'img': 'http://thirdwx.qlogo.cn/mmopen/Q3auHgzwzM5PS7HwWr3v4n4AZUIJoVtoWfCA8sUYj5hNiaiaNViaKicPnwN8NrgBOHpulXEMfsk3z5o5jnXiahDdLjw/132'
  },
  {
    'msg': '用户43***20 1分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '用户43***04 1分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '用户44***21 1分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '蒋**I 1分钟前提交了申办申请',
    'img': 'https://wx.qlogo.cn/mmopen/vi_32/DYAIOgq83epcjovYhk9CC4PwYh21DdF93sl3gibqlgZcASBgGmuTlbVbcG50icPfXbictLdpvh8ltL5bjejicVqnfA/132'
  },
  {
    'msg': '用户44***80 2分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '用户44***04 2分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '莫* 2分钟前提交了申办申请',
    'img': 'http://thirdwx.qlogo.cn/mmopen/K6CEv0Hv9Dc99ksj0ZcB8O626p6FJfyxCPPe3ibMdGfIdicmhItQEx5a1B0sLU4gLHwjYebPpSMFFymzVWVURVzQ/132'
  },
  {
    'msg': '王**川 3分钟前提交了申办申请',
    'img': 'https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLMGaT8xhWffKbIDSkewsREU6QNtQ8mN1D2rpIbicJiadObLCgnibiaTfcJYxbCYQAKMibpuR0ztHY2lNg/132'
  },
  {
    'msg': '用户44***78 3分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '用户44***54 3分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '用户44***67 4分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '用户43***21 4分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '壹**着 4分钟前提交了申办申请',
    'img': 'https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTK0WrQIptYLzeBAVTPhicaeBMviaFicdZeica2Y1gK1ancib9636pXKOdYshhvK8TyL1lkz1eAQrq9YXMw/132'
  },
  {
    'msg': '彭* 4分钟前提交了申办申请',
    'img': 'https://thirdwx.qlogo.cn/mmopen/vi_32/29AEWBpaXBMDwjY4hbuhx0sR8RicniaDGQOfMvjqtuAxwJkXNle1VNpAWSOXNpAb96pQruCF1l4PIMOkX5P4vd9w/132'
  },
  {
    'msg': '用户44***40 4分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '小**茶 5分钟前提交了申办申请',
    'img': 'https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJ42h2Qgmib4zJhcj5yLicicPFlxrWZibTIRsbTtE8h0zKiaxQ05oo3CZhBBVbKpYtQgmkp8U5DHfWhYIw/132'
  },
  {
    'msg': 'A**梁 5分钟前提交了申办申请',
    'img': 'http://thirdwx.qlogo.cn/mmopen/lOHpVm8ia81LWNgX35jPccBlDU0ibawyecFrrN28QxHPgWias3rRIoOkUnEU3GnB5D27mknll1udtzK2DKIbediabNLHD032YdHic/132'
  },
  {
    'msg': '用户41***90 5分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '用户44***67 6分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '用户44***86 6分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '用户44***06 7分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '用户44***34 8分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '用户44***01 8分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '用户44***59 8分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '王* 8分钟前提交了申办申请',
    'img': 'https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKmhJaxzOEptxicHhkNzBgxoCxB8IhCLtfOric0pmzLEb8RUkJAofd8noIOXC28gIW3xZicAUdQqibHVA/132'
  },
  {
    'msg': '我**葱 8分钟前提交了申办申请',
    'img': 'http://thirdwx.qlogo.cn/mmopen/0tdl2DrLhGOeUOhFDqWanBUBHHiazbw37Kxq6qYbptlkhn5uVA3vkicQvy0uMkm4oVLNhua9Xyib5PticicGqM8Fb6EGVPbwDQsXK/132'
  },
  {
    'msg': '冯**仪 8分钟前提交了申办申请',
    'img': 'http://thirdwx.qlogo.cn/mmopen/0tdl2DrLhGNQCb9HCic8MBicBialvqFOng6WAvicKuH0gZYHqsJ07B4xjjgekGVYXK3GIeCW5rTrTPVLgJdmJ0nEwhtnffjyrxTn/132'
  },
  {
    'msg': 'ζ**w 8分钟前提交了申办申请',
    'img': 'https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJTgNpkSibNiaDibORKibC3QszRhSXWxTIq6V8wsElcMGBwL0AAns4NtKL8azzOSmC6ViacB3O7szS2XEQ/132'
  },
  {
    'msg': '花**店 9分钟前提交了申办申请',
    'img': 'https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTK3fLmHRZU8qUKYHU3xBCdWLRibUuHRjByFrICVUojNEBMMCe1Bk3no3lqGPeicKIicT1b89gEIzGrbw/132'
  },
  {
    'msg': '用户44***82 9分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '用户43***66 9分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': 'A**喜 9分钟前提交了申办申请',
    'img': 'https://wx.qlogo.cn/mmopen/vi_32/DYAIOgq83eoNc4aUZJT2w6OLZbxJs7QLLuiaYTuOFvia3fS1Jt7asuSicibAjrDXcUOwyyM5zIv99L4LkKwGX58U8g/132'
  },
  {
    'msg': '用户44***18 10分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '用户44***07 10分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': 'R**༢ 11分钟前提交了申办申请',
    'img': 'http://thirdwx.qlogo.cn/mmopen/Q3auHgzwzM5HkEuoMIjnPcWVXbJC9sQoyAiakKr7PWOxwwku2ZSsEgNuJ574ukyw11I1m7v4AseWdEOOlEbqRhXBtpqJYIrnGia5boZCVvUP0/132'
  },
  {
    'msg': '用户44***48 11分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '用户44***15 11分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '大* 12分钟前提交了申办申请',
    'img': 'http://thirdwx.qlogo.cn/mmopen/PiajxSqBRaEKQnRw1Agp0ypWsKarrURcvvmlkby6AvfBG3xrNicJL3MibfvicVNEleBLCHypKtmQbnAD43BtyFYCNw/132'
  },
  {
    'msg': '隐* 12分钟前提交了申办申请',
    'img': 'https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKIgE33HuBN3CDClvPCBKfrJgoLc24u8coZE0trXCVDibNoxwZwBLFnka3icYJEZVPOw5XjR17UA3MA/132'
  },
  {
    'msg': 'A**意 12分钟前提交了申办申请',
    'img': 'https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJaxvP9YgELS4ia5iaF85ARUw3yibPDjgd4VnwxlSLXPwHDU8hxeFd4Jib1jMgXl5I5pW8z5I0rNkia0icw/132'
  },
  {
    'msg': '听**说 12分钟前提交了申办申请',
    'img': 'http://thirdwx.qlogo.cn/mmopen/sT4sMFviar1TeATRoM2P69YMP4ZvfWJCEflF3nbs5iaCDRibEIe7qUzG81KwwceGjtCxR9B2OmBlh0iaTUSySRwzgNic2Sa84WsX6/132'
  },
  {
    'msg': '用户44***61 13分钟前提交了申办申请',
    'img': ''
  },
  {
    'msg': '宁**鱼 13分钟前提交了申办申请',
    'img': 'https://wx.qlogo.cn/mmopen/vi_32/GVxOEKAiaGOZlm6lQibISPPFFf8jleWBD730uR8VLvMz7ISZGPKsicbbwaPhkZsS7CXQxfkKyw5Yur7NzSLfG1diaQ/132'
  },
  {
    'msg': '用户44***94 13分钟前提交了申办申请',
    'img': ''
  }
]
export const BASE_WEBCOS_URL = 'https://wecos.etczs.net'

// 货车详情页 详细步骤弹窗
export const APPLY_STEP_TRUCK = [
  {
    img: BASE_WEBCOS_URL + '/assets/images/index-step-detail-1-1114.png',
    t: '填写资料',
    tag: '',
    value: '填写车牌及ETC设备收件地址'
  },
  {
    img: BASE_WEBCOS_URL + '/assets/images/index-step-detail-2-truck.png',
    t: '选择办理方式',
    tag: '',
    value: '上传身份证，行驶证及车身照片'
  },
  {
    img: BASE_WEBCOS_URL + '/assets/images/index-step-detail-3-1114.png',
    t: '签约通行费扣款方式',
    tag: '',
    value: '用于高速通行后自动扣费'
  },
  {
    img: BASE_WEBCOS_URL + '/assets/images/index-step-detail-4-truck.png',
    t: '提交订单',
    tag: '',
    value: '免设备费，按不同产品支付服务费'
  },
  {
    img: BASE_WEBCOS_URL + '/assets/images/index-step-detail-4-1114.png',
    t: '安装激活',
    tag: '',
    value: '收到设备后按视频指引自助激活'
  }
]
